export const Turoa = 'turoa';
export const Waipori = 'waipori';
export const Aio = 'aio';
export const Futura = 'futura';
export const Maku = 'maku';
export const Minimalist = 'minimalist';
export const Kiri = 'kiri';
export const Rua = 'rua';
export const Aurajet = 'aurajet-technology';
export const Satinjet = 'satinjet-technology';
export const VJet = 'vjet-technology';
export const Airstream = 'airstream-technology';

export const PRODUCT_RANGES = [
      'Opal',
      'Tūroa',
      'Waipori',
      'Aio',
      'Futura',
      'Maku',
      'Minimalist',
      'Kiri',
      'Rua',
  ]; 